import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../../Styles/InputStyles";
import { getModeName } from "../../../helpers";

const ViewModal = ({ setViewDetail, selectedData }) => {
    const onClose = () => setViewDetail(false);

    return (
        <Container>
            <Header>
                <Title>View Details</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {selectedData?.paidByName || selectedData?.paidToName}
                    </span>
                    <span className="text-sm text-gray-600">
                        {'#' + selectedData?.paidByMobile || ''}
                    </span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className='text-gray-500 text-sm'>{'Amount Paid'}</span>
                    <span className='text-xl font-semibold text-gray-700'>
                        {'₹' + (selectedData?.amount || '0')}
                    </span>
                </div>
            </ProfileSection>

            <Content>
                <ScrollableContent>
                    <Wrapper>
                        <BtnWrapper>
                            <SectionTitle>Transaction Details</SectionTitle>
                        </BtnWrapper>
                        <Section>
                            <Row>
                                <FlexCol>
                                    <Label>Amount Paid</Label>
                                    <Value>{'₹' + (selectedData?.amount || '0')}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Payment Mode</Label>
                                    <Value>
                                        {getModeName(selectedData?.paymentMethod)}
                                    </Value>
                                </FlexCol>
                            </Row>
                            <Row>
                                <FlexCol>
                                    <Label>Due Date</Label>
                                    <Value>{selectedData?.paidDate
                                        ? moment(selectedData?.dueDate).format("DD, MMM YYYY")
                                        : '-'}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Payment Date</Label>
                                    <Value>
                                        {selectedData?.paidDate
                                            ? moment(selectedData?.paidDate).format("DD, MMM YYYY, hh:mm A")
                                            : '-'}
                                    </Value>
                                </FlexCol>
                            </Row>
                            <Row>
                                <FlexCol>
                                    <Label>Paid By</Label>
                                    <Value>{selectedData?.paidByName || '-'}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Paid To</Label>
                                    <Value>{selectedData?.paidToName || '-'}</Value>
                                </FlexCol>
                            </Row>
                            <Row className="grid-cols-1">
                                <FlexCol>
                                    <Label>Property</Label>
                                    <Value>{selectedData?.propName || '-'}</Value>
                                </FlexCol>
                            </Row>

                            <Row className="grid-cols-1">
                                <FlexCol>
                                    <Label>Payment For</Label>
                                    <Value>{selectedData?.name || '-'}</Value>
                                </FlexCol>
                            </Row>

                        </Section>

                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

export default ViewModal;

// ---------------- Styled Components ----------------
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1 gap-2`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-700 text-md break-all`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;